export default __webpack_public_path__ + "static/media/trehant.e7127e46.jpg";